import { checkUserValidity } from "./ExlyConnect.utils";
import { isRequestSuccessful } from "utils/Utils";
import { useExlyConnectStore } from "./store/useExlyConnectStore";
import { logError } from "utils/error";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { useEffect } from "react";

export const useCheckValidExlyConnectUser = () => {
  const setIsValidZoomUser = useExlyConnectStore(
    (state) => state.setIsValidZoomUser
  );
  const setWebinarMinutes = useExlyConnectStore(
    (state) => state.setWebinarMinutes
  );
  const setInvalidZoomUserError = useExlyConnectStore(
    (state) => state.setInvalidZoomUserError
  );

  useEffect(() => {
    handleCheckValidExlyConnectUser();
  }, []);

  const handleCheckValidExlyConnectUser = async () => {
    try {
      const response = await checkUserValidity();
      if (isRequestSuccessful(response?.status)) {
        setIsValidZoomUser(true);
        setWebinarMinutes(response.data.exlycon_webinar_minutes);
      }
    } catch (err) {
      const error = { ...err };
      setIsValidZoomUser(false);
      setWebinarMinutes(0);
      setInvalidZoomUserError(error?.body?.message || SOMETHING_WENT_WRONG);
      logError({
        error: err,
        occuredAt: "src/features/ExlyConnect/useCheckValidExlyConnectUser",
        when: "checking zoom user validity",
      });
    }
  };
};
